import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Banner from "../components/Banner";
import CTASection from "../components/CTASection";
import backgroundImage from "../img/banner/ZTO-Banner.png";
import headingLogo from "../img/default-image.jpg";
import "../css/Policy.css";
import "../css/Policy.css";

const Policy = () => {
  const navigate = useNavigate();

  const policies = [
    {
      id: "general-policy",
      title: "Chính Sách Chung",
      description: "Chính sách bảo hành và giải quyết tranh chấp",
      image: headingLogo, // Add image path later
    },
    {
      id: "secure-personal-info",
      title: "Chính Sách Bảo Mật Thông Tin Cá Nhân",
      description: "Bảo vệ quyền lợi và thông tin cá nhân của khách hàng",
      image: headingLogo,
    },
    {
      id: "check-order",
      title: "Chính Sách Kiểm Hàng",
      description: "Quyền kiểm tra hàng hóa trước khi nhận",
      image: headingLogo,
    },
    {
      id: "shipping-from-china",
      title: "Quy Định Về Ký Gửi Hàng Trung Quốc",
      description: "Điều kiện và quy trình ký gửi hàng hóa",
      image: headingLogo,
    },
    {
      id: "complaint-resolution",
      title: "Chính Sách Giải Quyết Khiếu Nại Dịch Vụ",
      description: "Quy trình tiếp nhận và xử lý khiếu nại",
      image: headingLogo,
    },
  ];

  const handleCardClick = (policyId) => {
    navigate(`/chinh-sach/${policyId}`);
  };

  return (
    <div>
      <Header />
      <Banner
        title="Chính sách"
        backgroundImage={backgroundImage}
        breadcrumb={
          <>
            <Link to={"/"} className="text-white p-2">
              Trang chủ
            </Link>
            <span>{">"}</span>
            <Link to={"/chinh-sach"} className="text-white p-2">
              Chính sách
            </Link>
          </>
        }
      />
      <div className="container my-5">
        <div className="row p-3 g-4">
          {policies.map((policy) => (
            <div key={policy.id} className="col-12 col-sm-6 col-lg-4">
              <div
                className="policy-card card h-100 shadow-sm border-0"
                onClick={() => handleCardClick(policy.id)}
              >
                <div className="policy-card-image-wrapper">
                  {policy.image ? (
                    <img
                      src={policy.image}
                      alt={policy.title}
                      className="card-img-top policy-card-image"
                    />
                  ) : (
                    <div className="policy-card-placeholder">
                      <i className="fas fa-file-alt fa-3x text-muted"></i>
                    </div>
                  )}
                </div>
                <div className="card-body">
                  <h5 className="card-title fw-bold">
                    {policy.title}
                  </h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <CTASection />
      <Footer />
    </div>
  );
};

export default Policy;

const GeneralPolicy = () => {
  return (
    <div className="card p-3 w-100 shadow-sm border mb-3">
      <h3 className="text-center">CHÍNH SÁCH CHUNG</h3>
      <p className="fw-bold fs-4">Chính Sách Bảo Hành</p>
      <p className="fw-bold">1. Mất Hàng - Không sử dụng bảo hiểm hàng hóa:</p>
      <p>
        Nếu hàng hóa bị mất trong quá trình vận chuyển và bạn không sử dụng dịch
        vụ bảo hiểm hàng hóa của <strong>ZTO VIỆT NAM</strong>, chúng tôi chỉ
        bồi thường gấp 3 lần số tiền vận chuyển của đơn hàng.
      </p>
      <p className="fw-bold">2. Mất Hàng - Sử dụng bảo hiểm hàng hóa:</p>
      <p>
        Nếu bạn sử dụng dịch vụ bảo hiểm hàng hóa (phí bảo hiểm là 5% giá trị
        hàng hóa kê khai), <strong>ZTO VIỆT NAM</strong> sẽ bồi thường 50% giá
        trị kiện hàng mà bạn đã kê khai.
      </p>
      <p className="fw-bold">3. Bảo Hành Theo Chính Sách Nhà Sản Xuất:</p>
      <p>
        Chính sách bảo hành đối với từng sản phẩm, hàng hóa, dịch vụ sẽ do Nhà
        sản xuất/Đơn vị phân phối quy định. <strong>ZTO VIỆT NAM</strong> sẽ hỗ
        trợ khách hàng liên hệ với nhà sản xuất hoặc đơn vị phân phối để giải
        quyết bảo hành.
      </p>
      <p className="fw-bold fs-4">Chính Sách Giải Quyết Tranh Chấp</p>
      <p className="fw-bold">1. Tiếp Nhận Khiếu Nại:</p>
      <p>
        <strong>ZTO VIỆT NAM</strong> sẽ tiếp nhận mọi khiếu nại liên quan đến
        giao dịch tại website <strong>ZTO VIỆT NAM</strong> và hỗ trợ khách hàng
        một cách tối đa.
      </p>
      <p>
        Các khiếu nại có thể liên quan đến thông tin đăng tải, chính sách bảo
        mật, chất lượng sản phẩm, v.v.
      </p>
      <p>Cách thức liên hệ khiếu nại:</p>
      <p>Gọi điện thoại: 036.475.8606</p>
      <p>Nhắn tin Zalo: 036.475.8606</p>
      <p className="fw-bold">2. Trách Nhiệm Giải Quyết Khiếu Nại:</p>
      <p>
        Khiếu nại liên quan đến dịch vụ của <strong>ZTO VIỆT NAM</strong> sẽ
        được giải quyết trong vòng 48 giờ kể từ khi nhận được khiếu nại.
      </p>
      <p>
        Nếu các bên không đạt được thỏa thuận qua thương lượng hoặc hòa giải,
        một trong hai bên có thể đưa vụ việc ra cơ quan nhà nước có thẩm quyền
        để giải quyết.
      </p>
      <p className="fw-bold fs-4">Chính Sách Đổi Trả Hàng Hóa</p>
      <p className="fw-bold">1. Điều Kiện Đổi/Trả Sản Phẩm:</p>
      <p>Lỗi kỹ thuật do nhà sản xuất.</p>
      <p>Sản phẩm bị rách, nứt, hư hỏng hoặc có dấu hiệu đã qua sử dụng.</p>
      <p>
        Sản phẩm không đúng so với đơn hàng về số lượng, mã sản phẩm, kích
        thước, màu sắc, chủng loại.
      </p>
      <p className="fw-bold">2. Thời Hạn Đổi/Trả Sản Phẩm:</p>
      <p>Quý khách có thể đổi/trả sản phẩm trong quá trình kiểm tra hàng.</p>
      <p>
        Sau khi ký nhận hàng và thanh toán, việc yêu cầu đổi trả sẽ không được
        chấp nhận.
      </p>
      <p className="fw-bold">3. Hình Thức Hoàn Phí:</p>
      <p>
        Nếu Quý khách đã thanh toán trước khi nhận hàng và đủ điều kiện đổi/trả
        sản phẩm, sau khi sản phẩm được hoàn trả, tiền sẽ được hoàn lại trong
        vòng 5-15 ngày làm việc qua hình thức chuyển khoản ngân hàng.
      </p>
    </div>
  );
};

const SecurePersonalInfoPolicy = () => {
  return (
    <div className="card p-3 w-100 shadow-sm border mb-3">
      <h3 className="text-center">CHÍNH SÁCH BẢO MẬT THÔNG TIN CÁ NHÂN</h3>
      <p>
        <strong>ZTO VIỆT NAM</strong> cam kết bảo vệ quyền lợi và thông tin cá
        nhân của khách hàng khi sử dụng dịch vụ của chúng tôi. Dưới đây là thông
        tin chi tiết về cách thức chúng tôi thu thập, sử dụng và bảo vệ thông
        tin cá nhân của khách hàng.
      </p>
      <p className="fw-bold">A. Mục đích và phạm vi thu thập thông tin</p>
      <p>
        Thông tin cá nhân của khách hàng được chúng tôi thu thập chủ yếu qua
        website, bao gồm họ tên, email, số điện thoại và địa chỉ giao hàng. Đây
        là những thông tin cần thiết để khách hàng có thể đăng ký tài khoản và
        sử dụng dịch vụ tại <strong>ZTO VIỆT NAM</strong>. Mục đích thu thập
        thông tin là để:
      </p>
      <p>
        • Quản lý tài khoản khách hàng.<br></br>• Xác nhận thông tin đơn hàng và
        giao dịch.<br></br>• Liên lạc với khách hàng để đảm bảo quyền lợi và
        hoàn tất giao dịch.
      </p>
      <p>
        Khách hàng cần chịu trách nhiệm bảo mật thông tin tài khoản của mình và
        thông báo ngay cho chúng tôi nếu có sự cố về bảo mật hoặc thông tin cá
        nhân bị lạm dụng.
      </p>
      <p className="fw-bold">B. Phạm vi sử dụng thông tin</p>
      <p>
        Thông tin cá nhân của khách hàng chỉ được sử dụng cho các mục đích sau:
      </p>
      <p>
        • Xác nhận đơn hàng và thực hiện giao dịch giao hàng.<br></br>• Cung cấp
        thông tin về sản phẩm và dịch vụ theo yêu cầu của khách hàng.<br></br>•
        Gửi email thông báo các chương trình khuyến mãi, ưu đãi và các thông tin
        liên quan đến sản phẩm của <strong>ZTO VIỆT NAM</strong>.<br></br>• Liên
        hệ với khách hàng trong những trường hợp cần thiết, chẳng hạn như giải
        quyết sự cố hoặc yêu cầu hỗ trợ.
      </p>
      <p>
        Chúng tôi cam kết không sử dụng thông tin cá nhân của khách hàng ngoài
        các mục đích trên.
      </p>
      <p className="fw-bold">C. Thời gian lưu trữ thông tin</p>
      <p>
        Thông tin cá nhân của khách hàng sẽ được lưu trữ trên máy chủ của chúng
        tôi cho đến khi khách hàng yêu cầu hủy bỏ hoặc khi có yêu cầu từ quản
        trị viên. Dù vậy, chúng tôi cam kết bảo mật mọi thông tin cá nhân trong
        suốt thời gian lưu trữ.
      </p>
      <p className="fw-bold">
        D. Quyền truy cập và chỉnh sửa thông tin cá nhân
      </p>
      <p>
        Khách hàng có quyền kiểm tra, chỉnh sửa hoặc yêu cầu xóa bỏ thông tin cá
        nhân của mình. Để thực hiện các quyền này, khách hàng vui lòng liên hệ
        với chúng tôi qua các phương thức liên hệ dưới đây.
      </p>
      <p className="fw-bold">E. Cam kết bảo mật thông tin cá nhân</p>
      <p>
        <strong>ZTO VIỆT NAM</strong> cam kết bảo vệ thông tin cá nhân của khách
        hàng một cách nghiêm ngặt. Chúng tôi chỉ thu thập và sử dụng thông tin
        khi có sự đồng ý của khách hàng, trừ trường hợp pháp luật yêu cầu khác.
      </p>
      <p>
        • Chúng tôi sẽ không cung cấp, chia sẻ hoặc tiết lộ thông tin cá nhân
        của khách hàng cho bất kỳ bên thứ ba nào mà không có sự đồng ý của khách
        hàng.<br></br>• Trong trường hợp dữ liệu cá nhân của khách hàng bị mất
        mát hoặc rò rỉ do sự tấn công của hacker, chúng tôi sẽ thông báo ngay
        cho cơ quan chức năng và khách hàng về sự cố này, đồng thời thực hiện
        các biện pháp khắc phục.
      </p>
      <p>
        Mọi thông tin giao dịch trực tuyến của khách hàng, bao gồm hóa đơn và
        chứng từ số hóa, sẽ được bảo mật tuyệt đối.
      </p>
      <p className="fw-bold">
        F. Cơ chế tiếp nhận và giải quyết khiếu nại về việc sử dụng sai mục đích
        thông tin cá nhân
      </p>
      <p>
        <strong>ZTO VIỆT NAM</strong> cam kết bảo vệ quyền lợi của khách hàng
        đối với việc sử dụng thông tin cá nhân. Nếu khách hàng phát hiện thông
        tin cá nhân của mình bị sử dụng sai mục đích hoặc vượt quá phạm vi đã
        thông báo, khách hàng có thể gửi khiếu nại và các chứng cứ liên quan qua
        số điện thoại <strong>036.475.8606</strong>
      </p>
      <p>
        Chúng tôi sẽ phản hồi trong vòng <strong>5 ngày làm việc</strong> (trừ
        thứ Bảy và Chủ Nhật) kể từ khi nhận được khiếu nại.
      </p>
      <p>
        Mọi tranh chấp hoặc khiếu nại phát sinh sẽ được giải quyết thông qua
        thương lượng, hòa giải, hoặc trọng tài. Nếu cần thiết, chúng tôi sẽ đưa
        vụ việc ra Tòa án theo quy định của pháp luật.
      </p>
      <hr></hr>
      <p>Thông tin liên hệ hỗ trợ khách hàng:</p>
      <p>
        • 📞 Hotline: 036.475.8606<br></br>• 🏢 Trụ sở: Số nhà 55, đường 181, xã
        Phú Thị, huyện Gia Lâm , TP Hà Nội, Gia Lâm, Vietnam
      </p>
      <hr></hr>
      <p>
        Chúng tôi cam kết luôn bảo mật thông tin của khách hàng và đảm bảo quyền
        lợi của bạn trong mọi trường hợp. Cảm ơn quý khách đã tin tưởng và sử
        dụng dịch vụ của <strong>ZTO VIỆT NAM</strong>!
      </p>
    </div>
  );
};

const CheckOrderPolicy = () => {
  return (
    <div className="card p-3 w-100 shadow-sm border mb-3">
      <h3 className="text-center">CHÍNH SÁCH KIỂM HÀNG</h3>
      <p className="fw-bold">1. Quyền kiểm tra hàng hóa:</p>
      <p>
        Trước khi thanh toán và nhận hàng, khách hàng có quyền kiểm tra sản phẩm
        ngay tại chỗ. Tuy nhiên, ZTO VIỆT NAM{" "}
        <strong>không hỗ trợ thử hàng</strong>.<br></br>
        Khách hàng cần mở gói hàng để kiểm tra, đảm bảo sản phẩm nhận được đúng
        mẫu mã, số lượng, chủng loại theo đơn đặt hàng.
        <br></br>
        Khách hàng không được phép thử hay sử dụng sản phẩm. Sau khi đồng ý với
        món hàng, khách hàng sẽ thanh toán cho nhân viên giao hàng (nếu là hình
        thức COD) và ký nhận hàng.
      </p>
      <p className="fw-bold">2. Phạm vi kiểm tra hàng hóa:</p>
      <p>
        Khách hàng được phép kiểm tra ngoại quan sản phẩm như số lượng, mã sản
        phẩm, kích thước, màu sắc.<br></br>
        Không kiểm tra: Việc mở seal (niêm phong) của sản phẩm, xé bao bì/tem
        nhãn hay bất kỳ hành động nào gây ảnh hưởng đến chất lượng sản phẩm.
      </p>
      <p className="fw-bold">3. Từ chối nhận hàng:</p>
      <p>
        Nếu không hài lòng với sản phẩm, khách hàng có thể từ chối nhận hàng.
        <br></br>
        Trong trường hợp này, phí hoàn hàng sẽ được tính tương đương với phí
        ship của đơn hàng.
      </p>
      <p className="fw-bold">4. Quy trình kiểm tra:</p>
      <p>
        Khi khách hàng kiểm tra đơn hàng, nhân viên giao nhận phải chờ đợi khách
        hàng kiểm tra hàng hóa trong gói hàng.<br></br>
        Nếu nhân viên từ chối cho kiểm tra, khách hàng có thể liên hệ với ZTO
        VIỆT NAM qua số điện thoại hỗ trợ: 036.475.8606
      </p>
      <p className="fw-bold">5. Trách nhiệm sau giao hàng:</p>
      <p>
        ZTO VIỆT NAM <strong>không chịu trách nhiệm</strong> về lỗi, số lượng,
        hay mẫu mã sản phẩm sau khi đơn hàng đã được giao thành công.
      </p>
      <p className="fw-bold">6. Lưu ý khi mở gói hàng:</p>
      <p>
        Khách hàng nên tránh sử dụng vật sắc nhọn để mở gói hàng nhằm tránh làm
        hư hỏng sản phẩm bên trong.<br></br>
        Nếu sản phẩm bị hư hỏng do lỗi từ phía khách hàng, ZTO VIỆT NAM sẽ không
        hỗ trợ đổi/trả hoặc bảo hành sản phẩm.
      </p>
      <p>
        Chính sách này nhằm đảm bảo quyền lợi của khách hàng trong việc nhận
        hàng và kiểm tra chất lượng sản phẩm một cách cẩn thận trước khi thanh
        toán.
      </p>
    </div>
  );
};

const RegulationsOnShippingFromChina = () => {
  return (
    <div className="card p-3 w-100 shadow-sm border mb-3">
      <h3 className="text-center">QUY ĐỊNH VỀ KÝ GỬI HÀNG TRUNG QUỐC</h3>
      <p className="fw-bold">ĐIỀU KIỆN VÀ QUY TRÌNH KÝ GỬI</p>
      <p className="fw-bold">1. Điều kiện ký gửi:</p>
      <p>
        ZTO VIỆT NAM chỉ nhận hàng ký gửi khi khách hàng đã{" "}
        <strong>tạo đơn "HÀNG KÝ GỬI"</strong> trên hệ thống của ZTO VIỆT NAM.
      </p>
      <p className="fw-bold">2. Quy trình ký gửi:</p>
      <p>
        Khách hàng cần tuân thủ đúng quy trình ký gửi được yêu cầu trên hệ thống
        của ZTO VIỆT NAM, bao gồm việc tạo đơn ký gửi và cung cấp đầy đủ thông
        tin chính xác.
      </p>
      <p className="fw-bold">3. Trách nhiệm khi không tuân thủ quy trình:</p>
      <p>
        Nếu khách hàng không thực hiện đúng quy trình ký gửi, như không tạo đơn
        ký gửi, cung cấp thông tin sai lệch hoặc không đầy đủ, ZTO VIỆT NAM sẽ{" "}
        <strong>không chịu trách nhiệm</strong> khi xảy ra rủi ro như mất hàng
        hoặc các sự cố khác.
      </p>
      <p className="fw-bold">
        CÁC MẶT HÀNG KHÔNG ĐƯỢC ZTO VIỆT NAM NHẬN ĐẶT HÀNG VÀ VẬN CHUYỂN
      </p>
      <p>
        Do yêu cầu về luật pháp và bảo quản hàng hóa, ZTO VIỆT NAM không nhận
        đặt hàng và vận chuyển các mặt hàng sau:
      </p>
      <p>
        1.{" "}
        <strong>
          Vũ khí, đạn dược, vật liệu nổ, trang thiết bị kỹ thuật quân sự
        </strong>{" "}
        (súng, đạn, đao, kiếm, dao kéo, ống ngắm, v.v.)<br></br>
        2. <strong>Pháo các loại</strong>, đèn trời, các loại thiết bị gây nhiễu
        máy đo tốc độ phương tiện giao thông.<br></br>
        3. <strong>Các chất ma túy và chất kích thích thần kinh</strong>.
        <br></br>
        4. <strong>Các sản phẩm dạng bột</strong>.<br></br>
        5. <strong>Các mặt hàng thực phẩm, dược phẩm, mỹ phẩm</strong>.<br></br>
        6. <strong>Hàng giả, hàng nhái</strong> (Kể cả hàng chính hãng của Nike,
        Adidas).<br></br>
        7. <strong>Sinh vật sống</strong>.<br></br>
        8. <strong>Các loại xuất bản phẩm cấm</strong> phổ biến và lưu hành tại
        Việt Nam:<br></br>
        Tem bưu chính thuộc diện cấm kinh doanh.<br></br>
        Thiết bị vô tuyến điện, thiết bị ứng dụng sóng vô tuyến không phù hợp
        với quy hoạch tần số.<br></br>
        Các loại văn hóa phẩm thuộc diện cấm.<br></br>
        9. <strong>Phương tiện vận tải tay lái bên phải</strong> (kể cả xe đã
        chuyển đổi tay lái), trừ các phương tiện chuyên dụng không tham gia giao
        thông.<br></br>
        10. <strong>Ô tô, mô tô, xe máy</strong> bị tẩy xóa, đục sửa số khung,
        số động cơ.<br></br>
        11. <strong>Vật tư, phương tiện đã qua sử dụng</strong> (ô tô, máy kéo,
        xe gắn máy, phụ tùng, động cơ, v.v.).<br></br>
        12. <strong>Hóa chất độc, thuốc bảo vệ thực vật</strong> và hóa chất
        trong Phụ lục III Công ước Rotterdam.<br></br>
        13. <strong>Các loại văn hóa phẩm đồi trụy, phản động</strong>, tài liệu
        phá hoại trật tự công cộng.<br></br>
        14. <strong>Hàng tiêu dùng đã qua sử dụng</strong> (dệt may, giày dép,
        điện tử, điện lạnh, thiết bị y tế, v.v.).<br></br>
        15. <strong>Phế liệu, phế thải, thiết bị làm lạnh sử dụng C.F.C</strong>
        .<br></br>
        16. <strong>Sản phẩm công nghệ thông tin đã qua sử dụng</strong> (điện
        thoại, laptop, v.v.).<br></br>
        17. <strong>Chất lỏng và các sản phẩm dạng lỏng</strong>.<br></br>
        18. <strong>Một số sản phẩm bị hạn chế nhập khẩu</strong> (vải cuộn,
        linh kiện máy móc công nghiệp, mỹ phẩm, màn hình máy tính, v.v.).
      </p>
      <p className="fw-bold">
        CHÍNH SÁCH GIẢI QUYẾT KHIẾU NẠI, BỒI THƯỜNG VỚI HÀNG KÝ GỬI:
      </p>
      <p>
        • ZTO VIỆT NAM không trực tiếp giao dịch với nhà cung cấp của Quý khách
        và không cung cấp dịch vụ kiểm hàng cho các đơn hàng ký gửi.<br></br>•
        Hàng hóa của Quý khách được vận chuyển đến kho của ZTO VIỆT NAM theo số
        kiện đã kê khai và chúng tôi không chịu trách nhiệm về tình trạng hư
        hỏng hoặc tính chính xác của hàng hóa trước khi đến kho.<br></br>•{" "}
        <strong>Dịch vụ bảo hiểm hàng hóa</strong>: Nếu có sự cố mất hàng, ZTO
        VIỆT NAM sẽ bồi thường 50% giá trị hàng hóa mà Quý khách kê khai. Phí
        bảo hiểm là 5% tổng giá trị đơn hàng.
        <br></br>• Nếu không sử dụng dịch vụ bảo hiểm, ZTO VIỆT NAM sẽ bồi
        thường gấp 3 lần phí vận chuyển của đơn hàng nếu có sự cố mất hoặc thất
        lạc hàng.<br></br>• <strong>Lưu ý</strong>: ZTO VIỆT NAM có quyền xác
        minh giá trị đơn hàng khi xảy ra tranh chấp. Nếu giá trị kê khai không
        đúng với giá trị thực tế, ZTO VIỆT NAM sẽ không chấp nhận đền bù thiệt
        hại.
      </p>
      <p className="fw-bold">LIÊN HỆ:</p>
      <p>
        • Nếu có vấn đề về đơn hàng, vui lòng liên hệ{" "}
        <strong>Hotline: 036.475.8606</strong> để được xử lý sớm nhất.
      </p>
    </div>
  );
};

const ServiceComplaintResolutionPolicy = () => {
  return (
    <div className="card p-3 w-100 shadow-sm border mb-3">
      <h3 className="text-center">CHÍNH SÁCH GIẢI QUYẾT KHIẾU NẠI DỊCH VỤ</h3>
      <p className="fw-bold">
        1. Thời gian thực hiện, tiếp nhận và xử lý khiếu nại:
      </p>
      <p>
        <strong>Thời gian gửi khiếu nại</strong>: Quý khách cần gửi khiếu nại
        trong vòng 24 giờ kể từ khi nhận hàng.
      </p>
      <p>
        <strong>Cách thức gửi thông tin</strong>: Quý khách có thể sử dụng chức
        năng khiếu nại trên website của chúng tôi:
      </p>
      <p>
        1. Đăng nhập vào tài khoản.<br></br>
        2. Chọn đơn hàng cần khiếu nại.<br></br>
        3. Lựa chọn trạng thái khiếu nại.<br></br>
        4. Cung cấp thông tin chi tiết (video kiểm kê sản phẩm, hình ảnh hàng
        hoá bị hư hỏng, mã vận đơn, hóa đơn nhà cung cấp, v.v...).
      </p>
      <p>
        <strong>Hình thức liên lạc</strong>: Chúng tôi sẽ liên hệ với Quý khách
        qua điện thoại hoặc thông qua phần khiếu nại trên đơn hàng.
      </p>
      <p>
        <strong>Thời gian phản hồi</strong>:
      </p>
      <p>
         Nếu khiếu nại liên quan đến bộ phận nghiệp vụ của công ty, chúng tôi
        sẽ phản hồi trong vòng 1 ngày.<br></br> Nếu khiếu nại liên quan đến nhà
        cung cấp, chúng tôi sẽ phản hồi trong vòng 3-4 ngày tuỳ thuộc vào sự hợp
        tác của nhà cung cấp.
      </p>
      <p className="fw-bold">2. Chính sách bồi thường:</p>
      <p>
        <strong>Mua hàng</strong>: Chúng tôi bồi thường 100% giá trị tiền hàng
        và phí mua hàng đối với các sản phẩm thiếu hoặc sai yêu cầu.
      </p>
      <p>
        <strong>Kiểm hàng</strong>: Chúng tôi bồi thường 100% giá trị tiền hàng
        và phí kiểm hàng đối với các sản phẩm thiếu hoặc không phát hiện lỗi sai
        theo quy định.
      </p>
      <p>
        <strong>Thất lạc hàng hoá</strong>: Nếu hàng hoá bị thất lạc do lỗi của
        ZTO VIỆT NAM, chúng tôi sẽ bồi thường 100% giá trị hàng hoá và các phí
        dịch vụ liên quan.
      </p>
      <p>
        <strong>Vận chuyển hàng hoá</strong>:
      </p>
      <p>
         Nếu hàng hoá bị thất lạc do bên vận chuyển thứ ba, ZTO VIỆT NAM không
        chịu trách nhiệm bồi thường. Quý khách cần tự thỏa thuận với đơn vị vận
        chuyển.<br></br> Nếu hàng hoá bị hư hỏng trong quá trình vận chuyển và
        Quý khách đã sử dụng dịch vụ đóng kiện gỗ, chúng tôi sẽ hoàn 100% giá
        trị thiệt hại và phí đóng gỗ nếu lỗi là do ZTO VIỆT NAM.<br></br> Nếu
        không sử dụng dịch vụ đóng gỗ, chúng tôi sẽ thương lượng mức bồi thường
        tùy theo mức độ thiệt hại.
      </p>
      <p>
        <strong>Hàng hóa quấn bóng khí</strong>: Nếu sản phẩm có nguy cơ vỡ hỏng
        cao và ZTO VIỆT NAM đã cảnh báo, chúng tôi không chịu trách nhiệm bồi
        thường nếu Quý khách không sử dụng dịch vụ quấn bóng khí. Nếu sử dụng
        dịch vụ, chúng tôi sẽ thương lượng mức bồi thường dựa trên thiệt hại
        thực tế.
      </p>
      <p>
        <strong>Đơn hàng ký gửi</strong>: ZTO VIỆT NAM không chịu trách nhiệm về
        tình trạng hư hỏng của hàng hoá trong các đơn hàng ký gửi. Nếu có bảo
        hiểm hàng hoá, chúng tôi sẽ bồi thường 50% giá trị hàng hoá nếu xảy ra
        mất mát hoặc hư hỏng.
      </p>
      <p className="fw-bold">3. Quy định lưu kho và phí lưu kho:</p>
      <p>
        <strong>Thời gian lưu kho</strong>: Hàng hoá sẽ được lưu tại kho của ZTO
        VIỆT NAM không quá 5 ngày. Nếu cần gia hạn, Quý khách phải thông báo
        trước và có sự chấp thuận từ ZTO VIỆT NAM.
      </p>
      <p>
        <strong>Phí lưu kho</strong>: Sau 10 ngày kể từ khi hàng hoá về kho mà
        Quý khách chưa nhận, chúng tôi sẽ tính phí lưu kho 5% giá trị tổng đơn
        hàng/ngày.
      </p>
      <hr></hr>
      <p className="fw-bold">
        C. CHÍNH SÁCH HỖ TRỢ ĐỐI VỚI CÁC KHIẾU NẠI KHÔNG NẰM TRONG PHẠM VI CAM
        KẾT DỊCH VỤ
      </p>
      <p>
        ZTO VIỆT NAM sẽ hỗ trợ giải quyết các khiếu nại không thuộc phạm vi cam
        kết dịch vụ, bao gồm:
      </p>
      <p>
        • Khiếu nại đối với nhà cung cấp khi vi phạm điều khoản giao dịch.
        <br></br>• Khiếu nại đối với đơn hàng không sử dụng dịch vụ kiểm hàng.
      </p>
      <p>
        Chúng tôi sẽ yêu cầu sự hợp tác của Quý khách trong suốt quá trình xử lý
        khiếu nại để đảm bảo giải quyết nhanh chóng và chính xác.
      </p>
      <hr></hr>
      <p className="fw-bold">D. CÁC LƯU Ý CẦN THIẾT</p>
      <p>
        • Chúng tôi khuyến khích Quý khách lựa chọn hàng hoá và phương thức đóng
        gói/vận chuyển phù hợp, cũng như chia sẻ rủi ro với ZTO VIỆT NAM khi xảy
        ra thiệt hại ngoài mong muốn.<br></br>• Việc đổi/trả hàng có nhiều rủi
        ro, chúng tôi không khuyến khích xử lý khiếu nại theo phương án này.
        <br></br>• Trong quá trình giải quyết khiếu nại, ZTO VIỆT NAM yêu cầu sự
        hợp tác chặt chẽ từ Quý khách để đảm bảo tính hiệu quả.
      </p>
    </div>
  );
};

export {
  GeneralPolicy,
  SecurePersonalInfoPolicy,
  CheckOrderPolicy,
  RegulationsOnShippingFromChina,
  ServiceComplaintResolutionPolicy,
};
